import React, { useMemo } from 'react';

import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { IntlMsg } from '../../_core/IntlMsg/intl-msg.component';
import { useCompanySportTerminology } from '../../../lib/stores/company.store';
import { REPORT_CARD_STATUS_FILTERS } from '../../ReportCardAccess/report-card-access.constants';
import { reportCardFilterLabels } from '../../ReportCardAccess/report-card-access.helpers';
import { getMessages as getReportCardMessages } from '../../ReportCardAccess/report-card-access.messages';
import { ReportCardStatusFilter } from '../../ReportCardAccess/report-card-access.types';
import { getMessages } from '../report.messages';

interface IRankingReportCardFilterProps {
  selected: ReportCardStatusFilter[];
  counts: Record<ReportCardStatusFilter, number>;
  onToggle: (filter: ReportCardStatusFilter) => void;
}

export const RankingReportCardFilter: React.FC<IRankingReportCardFilterProps> = ({ selected, counts, onToggle }) => {
  const termLookup = useCompanySportTerminology();
  const messages = useMemo(() => getMessages(termLookup), [termLookup]);
  const labels = useMemo(() => reportCardFilterLabels(getReportCardMessages(termLookup)), [termLookup]);

  return (
    <Box mb={0} display="flex" alignItems="center">
      <Box><strong><IntlMsg {...messages.lblReportCardFilter} /></strong></Box>
      {REPORT_CARD_STATUS_FILTERS.map(({ filter }) => (
        <FormControlLabel
          key={filter}
          style={{ marginLeft: 0 }}
          control={<Checkbox checked={selected.includes(filter)} onChange={() => onToggle(filter)} />}
          label={<IntlMsg {...messages.lblFilterOptionCount} values={{ label: <IntlMsg {...labels[filter]} />, count: counts[filter] }} />}
        />
      ))}
    </Box>
  );
};
